import ScoreCircle from './ScoreCircle';

interface Props {
  score: number;
  maxScore?: number;
  /** 위젯 가로/세로 픽셀 (좌측 카드 높이에 맞춰 측정해서 내려줌) */
  size?: number;
}

/** Figma 486:7791 종합 점수 위젯. 최종 점수 기준으로 등급/색 결정. */
const getGradeInfo = (ratio: number) => {
  if (ratio >= 0.8) return { label: '적합', color: '#4B93FF', bg: '#E1EDFF' };
  if (ratio >= 0.6) return { label: '양호', color: '#4B93FF', bg: '#E1EDFF' };
  if (ratio >= 0.4) return { label: '개선필요', color: '#10C01E', bg: '#E1F9E3' };
  return { label: '불리', color: '#FF5B5B', bg: '#FFE9E9' };
};

const ScoreWidget = ({ score, maxScore = 100, size = 198 }: Props) => {
  const ratio = maxScore > 0 ? score / maxScore : 0;
  const grade = getGradeInfo(ratio);
  const circleSize = Math.max(80, Math.round(size * 0.65));

  return (
    <div
      className="flex shrink-0 flex-col items-center justify-between gap-[8px] rounded-[12px] border border-gr-100 bg-white p-[16px]"
      style={{ width: size }}
    >
      <div className="flex w-full items-center justify-between">
        <span className="text-gr-800 Body1S16">종합 점수</span>
        <span
          className="rounded-[8px] px-[6px] py-[2px] Caption1M12"
          style={{ backgroundColor: grade.bg, color: grade.color }}
        >
          {grade.label}
        </span>
      </div>
      <ScoreCircle
        score={score}
        maxScore={maxScore}
        size={circleSize}
        color={grade.color}
      />
    </div>
  );
};

export default ScoreWidget;
